<template>
  <component
      :is="componentType"
      :datetime="formattedDatetime"
      class="chip"
      :class="chipClasses"
  >
    <Icon :icon="icon" />
    <span aria-hidden="true" v-html="label" />
    <span class="sr-only" v-html="srLabel" />
  </component>
</template>

<script>
import { defineComponent, computed, inject } from 'vue';
import Icon from "./Icon.vue";

export default defineComponent( {
  name: 'Chip',
  components: {
    Icon,
  },
  props: {
    date: {
      type: [ String, Number ], // Allow both string and number types
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  setup( props ) {
    const icon = computed( () => ( props.active ? 'dot-active' : 'dot' ) );
    const chipLabels = inject( 'chipLabels' );
    const chipClasses = computed( () => ( {
      'chip--active': props.active,
    } ) );

    const language = inject( 'language' );

    const label = computed( () => ( `${ props.active ? chipLabels?.active : chipLabels?.inactive }: ${ formattedTime.value }` ) );

    const srLabel = computed( () => ( `Status: ${ props.active ? chipLabels?.active : chipLabels?.inactive }, ${window.vrgz_variables.incidents.labels.last_updated}  ${ formattedTime.value }` ) );

    const parseDate = ( date ) => {
      if ( ! date ) return null;
      const timestamp = Number( date );
      const dateObject = ! isNaN( timestamp ) ? new Date( timestamp * 1000 ) : new Date( date );
      return isNaN( dateObject.getTime() ) ? null : dateObject;
    };

    const dateObject = parseDate( props.date );
    const componentType = computed( () => ( dateObject ? 'time' : 'p' ) );
    const formattedDatetime = computed( () => ( dateObject ? dateObject.toISOString() : null ) );
    const formattedTime = computed( () => {
      if ( ! dateObject ) return '';

      const date = new Intl.DateTimeFormat( language.value, {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      } ).format( dateObject );

      const time = new Intl.DateTimeFormat( language.value, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      } ).format( dateObject );

      return `${ date } - ${time}`;
    } );

    return {
      icon,
      chipClasses,
      componentType,
      label,
      formattedTime,
      formattedDatetime,
      srLabel
    };
  }
} );
</script>
